export default "\r\n<div class=\"col-xs-4\">\r\n    <ng-content></ng-content>\r\n</div>\r\n\r\n";